import React, { useCallback, useEffect, useState } from 'react';

import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';

import { COLOR } from 'utils/colors';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    testID?: string;
    progress?: number;
    duration?: number;
    label: string;
    buttonMinWidth: number;
    style?: StyleProp<ViewStyle>;
    onPress(): void;
};

function ProgressButton({
    duration = 0,
    progress = 0,
    label,
    buttonMinWidth,
    style,
    onPress,
    testID,
}: Props) {
    const [watchProgressWidth, setWatchProgressWidth] = useState(0);
    const [buttonWidth, setButtonWidth] = useState(buttonMinWidth);

    useEffect(() => {
        if (progress && duration) {
            setWatchProgressWidth(
                Math.min((progress * buttonWidth) / duration, buttonWidth),
            );
        } else {
            setWatchProgressWidth(0);
        }
    }, [duration, progress, buttonWidth]);

    const onTouchableOpacityLayout = useCallback(
        (event) => {
            const { width } = event.nativeEvent.layout;

            if (width !== buttonWidth) {
                setButtonWidth(width);
            }
        },
        [buttonWidth],
    );

    return (
        <TouchableOpacity
            style={[
                styles.buttonWatch,
                style,
                { minWidth: buttonMinWidth, backgroundColor: COLOR.primary },
            ]}
            onPress={onPress}
            onLayout={onTouchableOpacityLayout}
            testID={testID}
            accessibilityRole="button"
        >
            <View
                style={[
                    styles.buttonWatchProgress,
                    { width: watchProgressWidth },
                ]}
            />
            <Text bold category={ETextCategory.body1} color={ETextColor.black}>
                {label}
            </Text>
        </TouchableOpacity>
    );
}

export default ProgressButton;
